// 액션 타입 정의
const PRICING_MODAL = 'PRICING_MODAL';
// 액션 생섬함수 정의
export const editPricingModal = value => ({
  type: PRICING_MODAL,
  value
});
// 초기상태 정의
const initialState = {
  pricingModal: {
    isShow: false
  },
  isShow: false
};
// 리듀서 작성
export default function modalReducer(state = initialState, action) {
  switch (action.type) {
    case PRICING_MODAL:
      return {
        ...state,
        isShow: action.value
      };
    default:
      return state;
  }
}
